import classNames from 'classnames'
import type { FC } from 'react'
import React from 'react'

import { useTableContext } from './table-context'
import type { TableBodyProps } from './types'
import type { PrivateThemeUiProps } from '../../styles-system/create-component'
import { BoxPrivate } from '../_primitives/box/box'
import type { BoxProps } from '../_primitives/box/types'

export const TableBody: FC<TableBodyProps> = React.forwardRef<
  HTMLDivElement,
  BoxProps & PrivateThemeUiProps
>(function TableBody(props, ref) {
  const { variant = 'body', className, children, ...rest } = props
  const { variant: tableVariant } = useTableContext()
  // eslint-disable-next-line no-console
  // console.log('rendering tables.body')
  return (
    <BoxPrivate
      ref={ref}
      __themeKey="tables"
      variant={tableVariant ? `${tableVariant}.body` : variant}
      as="tbody"
      className={classNames(
        {
          'csg-tui-tbody': true
        },
        className
      )}
      {...rest}
    >
      {children}
    </BoxPrivate>
  )
})

export default TableBody
